import { render, staticRenderFns } from "./TraceyPageChat.vue?vue&type=template&id=7ebf393c&scoped=true"
import script from "./TraceyPageChat.vue?vue&type=script&lang=js"
export * from "./TraceyPageChat.vue?vue&type=script&lang=js"
import style0 from "./TraceyPageChat.vue?vue&type=style&index=0&id=7ebf393c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebf393c",
  null
  
)

export default component.exports